<template>
  <div>
    <div class="page-title">
      {{ $t('data.refund_transaction') }}
    </div>
    <div class="page-container">
      <RefundTransDetails />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Data_Payin',
  components: {
    RefundTransDetails: () => import('./components/RefundTransDetails.vue')
  }
}
</script>

<style scoped>
.page-container{

}
.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
</style>
